/* global Swiper */

const initCompletedProjectsSlider = () => {
  const root = document.querySelector('[data-completed-projects-container]');
  if (!root) {
    return;
  }

  const container = root.querySelector('[data-completed-projects-swiper]');
  if (!container) {
    return;
  }

  const btnPrev = root.querySelector('[data-btn-prev]');
  const btnNext = root.querySelector('[data-btn-next]');

  new Swiper(container, {
    slidesPerView: 2,
    slidesPerGroup: 2,
    spaceBetween: 10,
    grid: {
      rows: 2,
      fill: 'row',
    },
    navigation: {
      nextEl: btnNext,
      prevEl: btnPrev,
    },
    breakpoints: {
      1200: {
        slidesPerGroup: 4,
        slidesPerView: 4,
        spaceBetween: 20,
      },
    },
  });
};

export {initCompletedProjectsSlider};
